import type { SVGProps } from 'react';

export function FormatIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="10" y="14" width="44" height="6" rx="1" stroke="currentColor" strokeWidth="2" />
      <rect x="10" y="26" width="32" height="6" rx="1" stroke="currentColor" strokeWidth="2" />
      <rect x="10" y="38" width="40" height="6" rx="1" stroke="currentColor" strokeWidth="2" />
      <path d="M14 50L20 50" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M24 50L34 50" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
